import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import PageHeader from "@/components/PageHeader";
import { Reveal, Overline } from "@/components/Reveal";

const groups = [
  {
    title: "Pages",
    testid: "sitemap-group-pages",
    links: [
      { label: "Home", to: "/", testid: "sitemap-link-home" },
      { label: "Make a Payment", to: "/make-a-payment", testid: "sitemap-link-payment" },
      { label: "Customer Care", to: "/customer-care", testid: "sitemap-link-customer-care" },
      { label: "Frequently Asked Questions", to: "/faq", testid: "sitemap-link-faq" },
      { label: "Contact Customer Service", to: "/contact", testid: "sitemap-link-contact" },
    ],
  },
  {
    title: "Customer Care Sections",
    testid: "sitemap-group-care",
    links: [
      { label: "Vehicle Service Form", to: "/customer-care#vehicle-service", testid: "sitemap-link-vehicle-service" },
      { label: "Open a Support Ticket", to: "/customer-care#customer-support", testid: "sitemap-link-support-ticket" },
    ],
  },
  {
    title: "Legal",
    testid: "sitemap-group-legal",
    links: [
      { label: "Privacy Policy", to: "/privacy-policy", testid: "sitemap-link-privacy" },
      { label: "Terms of Use", to: "/terms-of-use", testid: "sitemap-link-terms" },
    ],
  },
  {
    title: "External",
    testid: "sitemap-group-external",
    links: [
      { label: "Online Payment Portal (BlytzPay)", to: "https://my.blytzpay.com/#/merchant/7acdb786-1f15-4eca-aff5-f4b1fea02516/login", external: true, testid: "sitemap-link-portal" },
      { label: "AutoCityCredit.com (Sister Company)", to: "https://www.autocitycredit.com/", external: true, testid: "sitemap-link-sister" },
    ],
  },
];

const Sitemap = () => (
  <>
    <PageHeader
      testid="sitemap-header"
      overline="Sitemap"
      title="Every page,"
      accent="one place."
      description="A complete index of the Concorde Auto Acceptance website."
    />
    <section className="pb-24 lg:pb-32" data-testid="sitemap-body">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {groups.map((g, i) => (
          <Reveal key={g.title} delay={i * 0.08}>
            <div
              data-testid={g.testid}
              className="h-full rounded-2xl border border-slate-900/10 bg-white/75 backdrop-blur-xl p-8"
            >
              <Overline>{g.title}</Overline>
              <div className="mt-5">
                {g.links.map((l) =>
                  l.external ? (
                    <a
                      key={l.label}
                      href={l.to}
                      data-testid={l.testid}
                      className="group/link flex items-center justify-between gap-4 py-3.5 border-b border-slate-900/10 text-slate-700 hover:text-slate-900 transition-colors duration-300"
                    >
                      <span className="text-sm font-medium">{l.label}</span>
                      <ArrowUpRight size={15} className="text-ember shrink-0 transition-transform duration-300 group-hover/link:translate-x-0.5 group-hover/link:-translate-y-0.5" />
                    </a>
                  ) : (
                    <Link
                      key={l.label}
                      to={l.to}
                      data-testid={l.testid}
                      className="group/link flex items-center justify-between gap-4 py-3.5 border-b border-slate-900/10 text-slate-700 hover:text-slate-900 transition-colors duration-300"
                    >
                      <span className="text-sm font-medium">{l.label}</span>
                      <ArrowUpRight size={15} className="text-ember shrink-0 transition-transform duration-300 group-hover/link:translate-x-0.5 group-hover/link:-translate-y-0.5" />
                    </Link>
                  )
                )}
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  </>
);

export default Sitemap;
